export default __webpack_public_path__ + "static/media/shutterstock_1667178667.0e9df37b.webp";